import React from "react";
import "@/index.css";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/contexts/AuthContext";
import { ThemeProvider } from "@/contexts/ThemeContext";
import LoginPage from "@/pages/LoginPage";
import RegisterPage from "@/pages/RegisterPage";
import ForgotPasswordPage from "@/pages/ForgotPasswordPage";
import ResetPasswordPage from "@/pages/ResetPasswordPage";
import AppShell from "@/pages/AppShell";
import DashboardPage from "@/pages/DashboardPage";
import PipelinePage from "@/pages/PipelinePage";
import ExpensesPage from "@/pages/ExpensesPage";
import TaxReportPage from "@/pages/TaxReportPage";
import IntegrationsPage from "@/pages/IntegrationsPage";
import PublicSharePage from "@/pages/PublicSharePage";
import BrokerageSettingsPage from "@/pages/BrokerageSettingsPage";
import AccountSecurityPage from "@/pages/AccountSecurityPage";
import TeamPage from "@/pages/TeamPage";
import ForcePasswordChangePage from "@/pages/ForcePasswordChangePage";

function PrivateRoute({ children }) {
  const { user, loading } = useAuth();
  if (loading) return <div className="p-10 text-sm text-neutral-500">Loading…</div>;
  if (!user) return <Navigate to="/login" replace />;
  if (user.password_reset_pending) return <ForcePasswordChangePage />;
  return children;
}

function PublicOnly({ children }) {
  const { user, loading } = useAuth();
  if (loading) return null;
  if (user) return <Navigate to="/" replace />;
  return children;
}

export default function App() {
  return (
    <div className="App">
      <AuthProvider>
        <ThemeProvider>
          <BrowserRouter>
            <Routes>
              <Route path="/share/:token" element={<PublicSharePage />} />
              <Route path="/login" element={<PublicOnly><LoginPage /></PublicOnly>} />
              <Route path="/register" element={<PublicOnly><RegisterPage /></PublicOnly>} />
              <Route path="/forgot-password" element={<PublicOnly><ForgotPasswordPage /></PublicOnly>} />
              <Route path="/reset-password/:token" element={<ResetPasswordPage />} />
              <Route path="/" element={<PrivateRoute><AppShell /></PrivateRoute>}>
                <Route index element={<DashboardPage />} />
                <Route path="pipeline" element={<PipelinePage />} />
                <Route path="expenses" element={<ExpensesPage />} />
                <Route path="report" element={<TaxReportPage />} />
                <Route path="integrations" element={<IntegrationsPage />} />
                <Route path="settings/brokerage" element={<BrokerageSettingsPage />} />
                <Route path="settings/account" element={<AccountSecurityPage />} />
                <Route path="settings/team" element={<TeamPage />} />
              </Route>
              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
          </BrowserRouter>
          <Toaster richColors closeButton position="top-right" />
        </ThemeProvider>
      </AuthProvider>
    </div>
  );
}
